import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { LinearProgress } from "@mui/material";
import { Redirect } from 'react-router-dom';
import PndApi from '../../../../../utils/pnd/PndRestApi';
import UpdateClientInformation from "./UpdateClientInformation";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";

const UpdateClientInformationModal = ({ modalShow, setModalShow, isTitle, clientInfoData }) => {

    useEffect(() => {
        getPlanDetails();
    
      }, [])

    const [loading, setLoading] = useState(false);
    const [isMapData, setMapData] = useState(null);
    const [addressMap, setAddressMap] = useState(null);
    const [isRedirect, setIsRedirect] = useState(false);
    const [paymentPlanOptions, setPaymentPlanOptions] = useState([]);
    const [subscriptionPlanOptions, setSubscriptionPlanOptions] = useState([]);

    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/pnd_establishment/view" />;
    }
    let Icon;
    const toggle = () => {
        setModalShow(prevState => !prevState)
    }
    const getPlanDetails = async () => {
        try {
          setLoading(true);
          const response = await PndApi.GetSubscriptionAndPaymentPlan();
          if (response.status === 200 && response.data.status === 200) {
            if (response?.data?.data?.customerPaymentPlans) {
              const paymentPlanOptions = response.data.data.customerPaymentPlans.map(plan => ({
                value: plan.paymentPlanId, // Adjust according to your data structure
                label: plan.planName // Adjust according to your data structure
              }));
              setPaymentPlanOptions(paymentPlanOptions);
            }
            if (response?.data?.data?.customerSubscriptionPlans) {
              const subscriptionPlanOptions = response.data.data.customerSubscriptionPlans.map(plan => ({
                value: plan.subscriptionPlanId, // Adjust according to your data structure
                label: plan.planName + " (" + plan.allowingCount + ") ", // Adjust according to your data structure,
                hubCount: plan?.allowedHubCount,
                operatorCount: plan?.allowedHubOperatorCount,
                deviceCount: plan?.allowedDeviceCount,
              }));
              setSubscriptionPlanOptions(subscriptionPlanOptions);
            }
          }
          else {
            showNotification(
              "theme-light",
              "ltr",
              `SuccessCode: ${response.data.status}`,
              `Message:${response.data.message}`,
            );
            return;
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: 500`,
            ERROR_MESSAGES.tryCatchError,
          );
        } finally {
          setLoading(false);
        }
      };
    const handleSubmit = async (formValues) => {
        try {
            setLoading(true);
            // formValues["operationType"] = 1;
            formValues["status"] = formValues.status ? 1 : 0;
            // formValues["operationType"] = 1;
            formValues["status"] = formValues.status ? 1 : 0;
            // if (formValues.dateRange !== undefined) {
            formValues["subscriptionStartDate"] = formValues["subscriptionStartDate"];
            formValues["subscriptionEndDate"] = formValues["subscriptionEndDate"];

            formValues["timeZoneInfo"]={
                timeZoneId:formValues["timeZoneInfo"]?formValues["timeZoneInfo"]["value"]:null,
              }
              if (formValues["timeZoneInfo"] === null) {
           
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: 500`,
                        `Message:Please select Time Zone.`,
                    );
                    return;
                
              }
             
              formValues["customerSubscriptionPlanInfo"] = {
                subscriptionPlanId: formValues["customerSubscriptionPlanInfo"]?formValues["customerSubscriptionPlanInfo"]["value"]:null,
              };

              if(!formValues["customerSubscriptionPlanInfo"]["subscriptionPlanId"]){
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Please select Subscription Plan`,
                );
                return;
              }
              formValues["customerPaymentPlanInfo"] = {
                paymentPlanId: formValues["customerPaymentPlanInfo"]?formValues["customerPaymentPlanInfo"]["value"]:null,
              };

              if( !formValues["customerPaymentPlanInfo"]["paymentPlanId"]){
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Please select Payment Plan`,
                );
                return;
              }

            // }
            /* if (formValues.communicationType !== undefined) {
                 formValues["communicationType"] = formValues.communicationType.map(option => option.value).join(', ');
             }
             if (formValues.supportingServices !== undefined) {
                 formValues["supportingServices"] = formValues.supportingServices.map(option => option.value).join(', ');
                 // Split the string into individual values using comma as delimiter
                 if (formValues["supportingServices"].includes(1)) {
                     formValues["isPickUp"] = true;
                 } else {
                     formValues["isPickUp"] = false;
                 }
                 if (formValues["supportingServices"].includes(2)) {
                     formValues["isDropOff"] = true;
                 } else {
                     formValues["isDropOff"] = false;
                 }
                 if (formValues["supportingServices"].includes(3)) {
                     formValues["isPnd"] = true;
                 } else {
                     formValues["isPnd"] = false;
                 }
 
                 formValues.dateRange = null;
             }*/
            let deliveryAddress = "";
            if (addressMap) {
                const buildingName = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 6);
                const landmark = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 4);
                const street = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 3);
                const area = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 2);
                const zone = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 7);
                const city = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 8);
                const emirates = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 1);
                const grl = addressMap.AddressElements.find(element => element.AddressElementTypeCode === 5);
                // if (buildingName) {
                //     deliveryAddress = deliveryAddress + buildingName.Value + ",";
                // }
                // if (landmark && !buildingName === landmark) {
                //     deliveryAddress = deliveryAddress + landmark.Value + ",";
                // }
                if (buildingName && buildingName?.Value!=="") {
                    deliveryAddress = deliveryAddress + buildingName.Value + ",";
                }
                if(buildingName?.Value==="" && landmark?.Value!==""){
                  deliveryAddress = deliveryAddress + landmark.Value + ",";
                }
                if (street) {
                    deliveryAddress = deliveryAddress + street.Value + ",";
                    formValues["street"] = street.Value
                }
                if (area) {
                    deliveryAddress = deliveryAddress + area.Value + ",";
                    formValues["area"] = area.Value;
                }
                if (zone) {
                    deliveryAddress = deliveryAddress + zone.Value + ",";
                }
                if (city) {
                    deliveryAddress = deliveryAddress + city.Value + ",";
                }
                if (emirates) {
                    deliveryAddress = deliveryAddress + emirates.Value;
                }
                if (grl) {
                    formValues["grcNo"] = grl.Value;
                }
               
            }
            if(deliveryAddress!==""){
                formValues["clientAddress"] = deliveryAddress;
            }else{
                if(clientInfoData?.clientAddress && clientInfoData?.clientAddress !== ""){
                    formValues["clientAddress"] = clientInfoData?.clientAddress;
                }
            }
            const response = await PndApi.AddOrUpdateInformapClientDetails(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                  }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
                return;
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"
                        style={{ color: "#2DD2E7" }}
                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light">
                                {clientInfoData &&
                                    <UpdateClientInformation onSubmit={handleSubmit} clientInfoData={clientInfoData} status={clientInfoData.status} address={clientInfoData.clientAddress} setMapData={setMapData} setAddressMap={setAddressMap} />
                                }
                            </span>
                        </span> */}
                        {clientInfoData &&
                                    <UpdateClientInformation onSubmit={handleSubmit} clientInfoData={clientInfoData} status={clientInfoData.status} address={clientInfoData.clientAddress} setMapData={setMapData} setAddressMap={setAddressMap}   paymentPlanOptions={paymentPlanOptions} subscriptionPlanOptions={subscriptionPlanOptions}/>
                                }
                    </div>

                </ModalBody>
            </Modal>
            {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}

        </div>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(UpdateClientInformationModal);
